// extracted by mini-css-extract-plugin
module.exports = {"phoneCode":"DeliveryAddressForm_phoneCode__19rxn","phoneInput":"DeliveryAddressForm_phoneInput__3vqgb"};